/**
 * @author xyguo
 * @description 角色管理==》人员维护==》添加人员管理页面,可在该角色下添加人员
 * @Date 2020/1/2
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool, utils_tool } from "@/tool";
import ListSelect from "./listSelect";
import { modelUtils } from "@/utils";

let { $$ } = utils_tool;
const { WizContainer, WizReduxTemplate } = framework_tool;
const {
  WizTabs
} = component_tool;

class NormalDealerAddList extends WizContainer {
  componentName = "NormalDealerAddList";

  constructor(props) {
    super(props);
    this.state = {
      selectedRows: []
    };
  }

  static defaultProps = {
    _ok: this._ok
  };



  /**
   * modal框的确定按钮触发
   * 可以在里面增加关闭modal前的操作及校验
   */
  _ok = () => {
    let listDate = this.state.selectedRows;
    //待接口完善后调试 1014 xyguo
      const dealerIds = [];
      if (!listDate || ($$.isArray(listDate) && !(listDate).length)) {
        wizNotice.warn("请先选择组织");
      } else {
        listDate.forEach(recordData => {
          dealerIds.push(
            recordData.businessId
          )
        });
        this.doAction({
          path: "normalDealer/add",
          payload: {
            key: "addNormalDealerKey",
            apiParams: {
              "dealerIds": dealerIds
            }
          }
        });
      }
  };

  updateRows = rows => {
    this.setState({
      rowData: new Date().getTime(),
      selectedRows: rows
    });
  };

  handleClear(id) {
    const { selectedRows } = this.state;
    id
      ? this.setState({
        selectedRows: selectedRows.filter(item => item.id !== id)
      })
      : this.setState({
        selectedRows: []
      });
  }


  propsAndStateOnChange = {
    normalDealerAddResult: this._setNormalDealerAddState.bind(this),
  };

  _setNormalDealerAddState(nextProps, nextState) {
    if (nextProps.normalDealerAddResult.code === 1) {
      wizNotice.success("操作成功");
      this.props.changeModal(false, true);
    } else {
      wizNotice.error(nextProps.normalDealerAddResult.msg);
    }
  }

  // _setRoleUserAddByUserNamesState(nextProps, nextState) {
  //   if (nextProps.addUsersForRoleByUserNameKey.code === 1) {
  //     wizNotice.success("操作成功");
  //     this.props.changeModal(false, true);
  //   } else {
  //     wizNotice.error(nextProps.addUsersForRoleByUserNameKey.msg);
  //   }
  // }

  // _onChange = (key) => {
  //   this.setState({ tabKey: key });
  // }

  checkUsers = (values) => {
    this.setState({ userNames: values });

  }

  _render() {
    // let record = this.props.location.record;
    return (
      <ListSelect
            selectedRows={this.state.selectedRows}
            updateRows={rows => this.updateRows(rows)}
            handleClear={id => this.handleClear(id)}
          />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { normalDealer } = state;
  const normalDealerAddResult = modelUtils.getModelEntity(normalDealer, 'addNormalDealerKey');
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'normalDealer')

  return {
    normalDealerAddResult: normalDealerAddResult,
    ...load
  };
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(NormalDealerAddList);
